import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { propertyData } from '../mockData';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { language } = useLanguage();
  const content = (propertyData[language] || propertyData.en).footer;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-center md:text-left">
            <h3 className="text-xl font-semibold mb-2">Skopelos Property</h3>
            <p className="text-slate-400">
              © {currentYear} {content.rights}
            </p>
          </div>
          <div className="flex gap-6">
            <Link 
              to="/privacy" 
              className="text-slate-400 hover:text-[#d4845f] transition-colors"
              data-testid="footer-privacy-link"
            >
              {content.privacy}
            </Link>
            <Link
              to="/data-deletion"
              className="text-slate-400 hover:text-[#d4845f] transition-colors"
              data-testid="footer-deletion-link"
            >
              Delete My Data
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;